import {Btn, EmptyFlexDiv, FlexColumnSection, FlexDiv, FlexRowSection, SmallText} from "../../styles/globalStyles";
import {t} from "i18next";
import FormInput from "../../components/UI/FormInput";
import CustomSelect from "../../components/UI/CustomSelect";
import {Checkbox} from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import React, {useEffect, useMemo, useRef, useState} from "react";
import useScreenSize from "../../helpers/hooks/useScreenSize";
import styled from "styled-components";
import {Colors} from '@arboxappv4/shared/src/styles/Colors'
import {getLocationsForPurchase} from "../../helpers/functions";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {PLUGIN_REFERER, SITE_LEAD_FORM_SETTINGS} from "../../../../src/constants";

const LeadForm = (props) => {
    const {errors, values, setFieldValue, HPGroupId, validationSchema, isInnerComponent, handleSubmit, initialValues} = props
    const {isMobile} = useScreenSize()
    const box = useSelector(state => state.site.box)
    const referrer = useSelector(state => state.site?.referrer)
    const locations = useMemo(() => getLocationsForPurchase(true, HPGroupId),[box])
    const [submitted, setSubmitted] = useState(false);
    const [emailError, setEmailError] = useState(null);
    const [allLocationsSelected, setAllLocationsSelected] = useState(false)
    const recaptchaRef = useRef()
    const [searchParams] = useSearchParams();
    const params = useMemo(() => Object.fromEntries([...searchParams]), [searchParams]);
    const isPlugin = referrer === PLUGIN_REFERER

    useEffect(() => {
        if(params.allLocations === 'true') {
            setAllLocationsSelected(true)
        } else {
            setFieldValue('locations_box_fk', Number(params.location))
        }
    }, [params, initialValues]);

    useEffect(()=> {
        console.log('values', values)
        console.log('errors', errors)
    }, [values, errors])

    const isRequiredField = (field) => {
        return box?.boxes_settings?.find(setting => setting.prop_name === SITE_LEAD_FORM_SETTINGS)?.properties?.[field]?.required
    }

    const inputLabel = (name, label) => {
        if(validationSchema && validationSchema.fields[name] && isRequiredField(name)) {
            return `${label}*`
        }
        return label
    }

    const setAllowSmsAndEmail = (val) => {
        setFieldValue('allow_mailing_list', val ? 'yes' : 'no')
        setFieldValue('allow_sms', val ? 'yes' : 'no')
    }

    const submit = () => {
        setSubmitted(true)
        handleSubmit()
    }

    return (
        <FlexRowSection>
            <FlexColumnExtended isMobile={isMobile} isPlugin={isPlugin} gap={'23px'}>
                <FlexColumnSection gap={'24px'}>
                    <FlexDiv dir={(isPlugin || isMobile) ? 'column' : 'row'} gap={'20px'}>
                        <FormInput label={inputLabel('first_name', t('first-name'))} initValue={values.first_name} value={values.first_name} error={(submitted && errors.first_name) ? errors.first_name : null} onChangeCallback={(val) => setFieldValue('first_name', val)} autoComplete={'given-name'} id="firstName" flex={1}/>
                        <FormInput label={inputLabel('last_name', t('last-name'))} initValue={values.last_name} value={values.last_name} error={(submitted && errors.last_name) ? errors.last_name : null} onChangeCallback={(val) => setFieldValue('last_name', val)} autoComplete={'family-name'} id="lastName" flex={1}/>
                    </FlexDiv>
                    <FlexDiv dir={(isPlugin || isMobile) ? 'column' : 'row'} gap={'20px'}>
                        <FormInput label={inputLabel('email', t('email'))} initValue={values.email} value={values.email} error={(submitted && errors.email) ? errors.email : emailError} onChangeCallback={(val) => setFieldValue('email', val)} type={'email'} autoComplete={'email'} inputMode={'email'} id={'email'} flex={1} />
                        <FormInput label={inputLabel('phone', t('phone'))} initValue={values.phone} value={values.phone} error={(submitted && errors.phone) ? errors.phone : null} onChangeCallback={(val) => setFieldValue('phone', val)} type={'phone'} autoComplete={'phone'} id={'phone'} flex={1} inputMode={'tel'}/>
                    </FlexDiv>
                    {
                        allLocationsSelected && locations && locations.length > 1 &&
                            <FormInput label={`${t('location')}*`} value={values.locations_box_fk} error={(submitted && errors.locations_box_fk) ? errors.locations_box_fk : null} flex={1}>
                                <CustomSelect onChange={(val) => setFieldValue('locations_box_fk', val)} options={locations} defaultValue={values.locations_box_fk}/>
                            </FormInput>
                    }
                    <FlexColumnSection flex={'none'} gap={'10px'}>
                        <FlexDiv>
                            <FormInput textArea={true} label={inputLabel('comment', t('comment'))} initValue={values.comment} value={values.comment} error={(submitted && errors.comment) ? errors.comment : null} onChangeCallback={(val) => setFieldValue('comment', val)} id={'comment'} flex={1} rows={2} maxLength={500}/>
                        </FlexDiv>
                        <Checkbox checked={values.allow_sms === 'yes' && values.allow_mailing_list === 'yes'} onChange={(val) => setAllowSmsAndEmail(val.target.checked)} style={{width: 'fit-content'}}>
                            <SmallText>{t('allow-mail-and-sms')}</SmallText>
                        </Checkbox>
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={process.env.SITE_REGISTER_RECAPTCHA}
                            size="invisible"
                        />
                    </FlexColumnSection>
                </FlexColumnSection>
                <FlexRowSection height={'38px'} flex={'none'} justify={!isPlugin ? 'start' : 'end'} >
                    <Btn type={'primary'} onClick={submit}>{t('send')}</Btn>
                </FlexRowSection>
            </FlexColumnExtended>
        </FlexRowSection>

    )
}

export default LeadForm

const FlexColumnExtended = styled(FlexColumnSection)`
  padding: ${({isPlugin, isMobile}) => (isPlugin || isMobile) ? '16px' : '16px 0px 49px 0px'};
  background: ${({isMobile, isPlugin}) => isPlugin && !isMobile ? Colors.white : 'none'};
  box-sizing: border-box;
  border-radius: 5px;
`;